<mat-sidenav-container class="layout-container">
  <mat-sidenav #drawer mode="side" opened class="sidenav">
    <mat-nav-list>
      <a mat-list-item routerLink="/dashboard">
        <mat-icon>home</mat-icon>
        <span>Home</span>
      </a>
      <a mat-list-item routerLink="/bulk-activation">
        <mat-icon>select_all</mat-icon>
        <span>QR Codes</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar color="primary" class="navbar">
      <button mat-icon-button (click)="drawer.toggle()" class="menu-button">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="app-title">PuMP Activation QR Generator</span>
      <span class="spacer"></span>
      <span class="app-version">Version: v{{ appVersion }}</span>
      <button mat-icon-button (click)="qrAppLogout()" class="logout-button" matTooltip="{{'LogoutAppToolTip'|translate}}">
        <mat-icon>exit_to_app</mat-icon>
      </button>
    </mat-toolbar>

    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>